module.exports = __webpack_public_path__ + "static/avatar-d9e811c57a0d07f90194b44b3534a794.png";